<template>
  <div class="xc-page xc-page-full">
    <!-- 分栏布局 -->
    <div class="xc-page-main">
      <!-- 面包屑 -->
      <div class="xc-breadcrumb">
        <a>首页</a>
      </div>
      <iframe :src='path' frameborder="0" allowtransparency="true"  style="width: 100%; visibility: inherit; background-color: #f8f8f8; z-index: 0;"></iframe>
    </div>
  </div>
</template>

<script>
const adminPath = process.env.VUE_APP_ADMIN_PATH;
export default {
  name: "adminHome",
  data() {
    return {
      path: `${adminPath}/reportforms/data`
    };
  },
};
</script>

<style scoped lang="scss">
.xc-page-main {
  background: #f8f8f8;
}

.xc-page {
  background: #f8f8f8;
}
</style>

